import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	token: 'f09e99df-de0c-456c-ac04-ceb6b39a005c',
	culture: {
		base: 'Default',
		default: 'en-GB',
	},
	core: {
		serviceUrl: 'https://api-rel.fundpress.io',
		skeletonLoaders: {
			variables: [
				{
					key: 'fillColor',
					value: '#dddddd',
				},
			],
			loaders: [
				{
					id: 'ksys-app-start',
					breakpoints: [
						{
							minWidthInPixels: 0,
							style: {
								height: '86px',
							},
							children: [
								{
									'fill': '{fillColor}',
									'x': '0px',
									'y': '11.90625px',
									'height': '28px',
									'width': '100%',
								},
								{
									'fill': '{fillColor}',
									'x': '0px',
									'y': '59.8125px',
									'height': '18px',
									'width': '100%',
								},
							],
						},
					],
				},
			],
		},
	},
	data: {
		entityMapping: {
			rootQueryId: 'entitiesForCards',
			rootEntityType: 'FUND',
			childEntityType: 'CLSS',
			childQueryId: 'childEntities',
		},
		context: {
			entities: [
				{
					id: 'entitiesForCards',
					inputs: [

					],
					requestBodyQueries: {
						type: 'FUND',
						search: [
							{
								matchtype: 'MATCH',
								property: {
									queryOptionsType: 'none',
									value: 'fund_code',
								},
								values: {
									queryOptionsType: 'input',
									key: 'funds',
									transforms: [
										{
											transformOptionsType: 'split',
											splitSeparator: ',',
										},
									],
								},
							},
						],
					},
					requestBody: {

					},
				},
				{
					id: 'childEntities',
					inputs: [

					],
					requestBodyQueries: {
						type: 'CLSS',
						include: {
							documents: {
								joinSpec: [
									{
										joinTo: 'isin',
										joinFrom: 'isin',
										search: [],
									},
								],
							},
						},
						search: [
							{
								matchtype: 'MATCH',
								property: {
									queryOptionsType: 'none',
									value: 'fund_code',
								},
								values: {
									queryOptionsType: 'property',
									entityType: 'FUND',
									code: 'fund_code',
									transforms: [
										{
											transformOptionsType: 'split',
											splitSeparator: ',',
										},
									],
								},
							},
						],
					},
					requestBody: {
						sort: [
							{
								key: 'short_name',
								direction: 'ASC',
							},
						],
					},
				},
			],
		},
	},
	components: {
		app: {
			globalRedirectButtonProps: {
				redirect: {
					defaultUrl: '/testing',
				},
				text: 'Explore All Funds',
			},
			headingProps: {
				title: 'Related Funds',
				level: 1,
			},
			carouselProps: {
				componentsToShow: 2,
				infiniteScroll: true,
				autoPlayInterval: 5000,
				hideDots: true,
			},
			redirects: [
				{
					id: 'fund',
					redirect: {
						defaultUrl: '/fund/{fundCode}/{isin}',
					},
					payloadQuery: {
						queryOptionsType: 'object',
						fields: [
							{
								name: 'fundCode',
								query: {
									queryOptionsType: 'property',
									entityType: 'FUND',
									code: 'fund_code',
								},
							},
							{
								name: 'isin',
								query: {
									queryOptionsType: 'property',
									entityType: 'CLSS',
									code: 'isin',
								},
							},
						],
					},
				},
			],
		},
		fundCard: {

			gridProps: {
				breakpoints: [
					{
						size: 'xsmall',
						modifier: 'up',
						props: {
							grid: {
								rows: [
									{
										columns: [
											{
												components: [
													{
														key: 'components.definitionList',
													},
													{
														key: 'base.heading',
														queries: {
															level: {
																queryOptionsType: 'none',
																value: 2,
															},
															title: {
																queryOptionsType: 'property',
																entityType: 'FUND',
																code: 'fund_name',
															},
														},
													},
													{
														key: 'base.text',
														props: {
															value: 'Lorem ipsum dolor sit amet',
														},
													},
													{
														key: 'components.childDropdown',
													},
													{
														key: 'components.redirectButton',
														props: {
															redirectId: 'fund',
															childProps: {
																text: 'Go to fund page',
															},
														},
													},
												],
											},
										],
									},
								],
							},
						},
					},
				],
			},
		},
		factList: {
			factListProps: {
				queries: {
					items: [
						{
							title: {
								queryOptionsType: 'none',
								value: 'Currency',
							},
							value: {
								queryOptionsType: 'property',
								entityType: 'CLSS',
								code: 'ccy',
							},
						},
					],
				},
			},
		},
		summaryBlocks: {
			summaryBlocksProps: {
				props: {
					breakpoints: [
						{
							size: 'small',
							modifier: 'up',
							props: {
								itemsPerRow: 3,
							},
						},
					],
				},
				queries: {
					blocks: [
						{
							title: {
								queryOptionsType: 'none',
								value: 'Launch Date',
							},
							value: {
								queryOptionsType: 'property',
								entityType: 'FUND',
								code: 'launch_date',
								format: {
									type: 'date',
									options: {
										day: '2-digit',
										month: 'short',
										year: '2-digit',
										placeholderKey: 'date',
									},
								},
							},
						},
						{
							title: {
								queryOptionsType: 'none',
								value: 'ISIN',
							},
							value: {
								queryOptionsType: 'property',
								entityType: 'CLSS',
								code: 'isin',
							},
						},
						{
							title: {
								queryOptionsType: 'none',
								value: 'Documents',
							},
							dataType: {
								queryOptionsType: 'none',
								value: 'document-tiles',
							},
							documentTilesProps: {
								tiles: [
									{
										_queryResponseMappings: [
											{
												key: 'document',
												children: [
													{
														key: 'label',
													},
													{
														key: 'fileName',
													},
												],
											},
										],
										document: {
											queryOptionsType: 'documents',
											entityType: 'CLSS',
											collectionItemConditional: {
												conditions: [
													{
														field: 'meta.document_type.value',
														value: 'Factsheet',
													},
												],
											},
											index: 0,
										},
										label: {
											value: 'Factsheet',
											queryOptionsType: 'none',
										},
										fileName: {
											value: '{sub:title} - {sub:isin}',
											queryOptionsType: 'none',
											subQueries: [
												{
													queryId: 'title',
													queryOptionsType: 'response',
													key: 'title',
												},
												{
													queryId: 'isin',
													queryOptionsType: 'response',
													key: 'meta.isin.value',
												},
											],
										},
									},
								],
							},
						},
					],
				},
			},
		},
		childDropdown: {
			label: {
				queryOptionsType: 'property',
				entityType: 'CLSS',
				code: 'short_name',
			},
		},
		documentDownload: {
			props: {
				iconPosition: 'before',
			},
			documentsQuery: {
				queryOptionsType: 'documents',
				entityType: 'CLSS',
			},
			availableLabelQuery: {
				queryOptionsType: 'none',
				value: 'Documents',
			},
			fileNameQuery: {
				value: '{sub:title} - {sub:isin}',
				queryOptionsType: 'none',
				subQueries: [
					{
						queryId: 'title',
						queryOptionsType: 'response',
						key: 'title',
					},
					{
						queryId: 'isin',
						queryOptionsType: 'response',
						key: 'meta.isin.value',
					},
				],
			},
		},
		definitionList: {
			definitionListProps: {
				queries: {
					termSuffix: {
						queryOptionsType: 'none',
						value: ': ',
					},
					items: [
						{
							term: {
								queryOptionsType: 'none',
								value: 'ISIN',
							},
							definition: {
								queryOptionsType: 'property',
								entityType: 'CLSS',
								code: 'isin',
							},
						},
					],
				},
			},
		},
	},
	assetOverrides: {
		base: {
			carousel: {
				navLeft: 'CarouselNavArrowLeftIcon.svg',
				navRight: 'CarouselNavArrowRightIcon.svg',
			},
		},
	},
};
